import React from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { Footer } from './Footer'
import { useUser } from '@renderer/context/UserContext'
import { PageHeaderProvider } from '@renderer/context/PageHeaderContext'
import { PageTransition } from './PageTransition'
import { BreadcrumbBar } from './layout/BreadcrumbBar'
import { BreadcrumbProvider } from '@renderer/context/BreadcrumbContext'

export const Layout: React.FC = () => {
  const { user } = useUser()

  return (
    <BreadcrumbProvider>
      <PageHeaderProvider>
        <div className="h-screen flex bg-[#F5F5F5] font-aurilearn">
          <Sidebar />
          <div className="flex flex-1 flex-col overflow-hidden bg-[#faf9f5]">
            <Header userEmail={user?.email} />
            <BreadcrumbBar />
            <main className="flex-1 overflow-y-auto">
              <div className="p-4 md:p-8 lg:p-[41px]">
                <PageTransition>
                  <Outlet />
                </PageTransition>
              </div>
            </main>
            <Footer />
          </div>
        </div>
      </PageHeaderProvider>
    </BreadcrumbProvider>
  )
}
